import React, { useState } from 'react'
import { RelatedMediaSectionProps, RelatedMediaTableSorting, RelatedMediaTableSortProps, relatedMediaTableWidths } from './RelatedMediaSection.types'
import styles from './RelatedMediaSection.module.scss'
// import cl from 'classnames'
import { SectionContainer } from '../SectionContainer'
import { H2 } from '../H2'
import { Button } from '../Button'
import { TableContainer } from '../TableContainer'
import { TableHeader } from '../TableHeader'
import { TableBodyContainer } from '../TableBodyContainer'
import { TableBodyLine } from '../TableBodyLine'
import { Text1 } from '../Text1'
import { capitalize } from '@material-ui/core'
import { ObjectsPopupSelector } from 'components/common'
import { inject } from 'mobx-react'
import { PROJECT_STORE } from 'store'
import { observer } from 'mobx-react-lite'
import { NoneLabel } from '../NoneLabel'
import { getSortingResult, isProjectPublished, SortDirection } from 'utilities'
import { TableTagsCell } from '../TableTagsCell'
import cl from 'classnames'

const RelatedMediaSectionComponent = (props: RelatedMediaSectionProps) => {
  const {
    [PROJECT_STORE]: {
      getVovProjects,
      vovProjectList
    },
    relatedMedia,
    onChange
  } = props

  const hasRelatedMedia = Boolean(relatedMedia && relatedMedia.length)

  const [showPopup, setShowPopup] = useState(false)
  const [selectedObjectsList, setSelectedList] = useState([])
  const [sorting, setSorting] = useState<RelatedMediaTableSorting>({
    sortProp: RelatedMediaTableSortProps.TITLE,
    sortDirection: SortDirection.DESC
  })

  const onSortingChange = (sortProp: RelatedMediaTableSortProps) =>
    (sortDirection: SortDirection) => {
      setSorting({ sortProp, sortDirection })
    }

  const isColumnMarked = (sortProp: RelatedMediaTableSortProps) => {
    return sorting.sortProp === sortProp
  }

  const getSortDirection = (sortProp: RelatedMediaTableSortProps) => {
    return isColumnMarked(sortProp)
      ? sorting.sortDirection
      : SortDirection.DESC
  }

  const handleManageRelatedMediaClick = () => {
    getVovProjects()
    setSelectedList(relatedMedia || [])
    setShowPopup(true)
  }

  const closePopup = () => setShowPopup(false)

  const setSelectedProjectsList = () => {
    closePopup()
    if (
      selectedObjectsList.map(p => p.id).join() !==
      (relatedMedia || []).map(p => p.id).join()
    ) {
      onChange && onChange(selectedObjectsList)
    }
  }

  const projects = [...(relatedMedia || [])]
  projects.sort((a, b) => {
    const { sortProp, sortDirection } = sorting

    switch (sortProp) {
      case RelatedMediaTableSortProps.TITLE: {
        return getSortingResult(a.name, b.name, sortDirection)
      }
      case RelatedMediaTableSortProps.TYPE: {
        return getSortingResult(a.type, b.type, sortDirection)
      }
      case RelatedMediaTableSortProps.TAGS: {
        return getSortingResult(a.tags, b.tags, sortDirection)
      }
      case RelatedMediaTableSortProps.GENRE: {
        return getSortingResult(a.genresAsString, b.genresAsString, sortDirection)
      }
      case RelatedMediaTableSortProps.STATUS: {
        return getSortingResult(a.status, b.status, sortDirection)
      }
      default: return 0
    }
  })

  return (
    <SectionContainer className={styles.container} extraPaddingBottom={hasRelatedMedia}>
      <H2>Related media</H2>
      <Button
        preset='secondary'
        className={styles.manageButton}
        onClick={handleManageRelatedMediaClick}
      >
        Manage related media
      </Button>

      {hasRelatedMedia
        ? (
          <TableContainer noBoxShadow className={cl(styles.tableContainer, styles.thinScroll)} style={ { overflow: 'auto' } }>
            <TableHeader
              noFilters
              tableColumns={[
                {
                  label: 'title',
                  // widthPercentage: relatedMediaTableWidths.title,
                  widthPx: relatedMediaTableWidths.title,
                  sortDirection: getSortDirection(RelatedMediaTableSortProps.TITLE),
                  setSortDirection: onSortingChange(RelatedMediaTableSortProps.TITLE),
                  isColumnMarked: isColumnMarked(RelatedMediaTableSortProps.TITLE)
                },
                {
                  label: 'type',
                  // widthPercentage: relatedMediaTableWidths.type,
                  widthPx: relatedMediaTableWidths.type,
                  sortDirection: getSortDirection(RelatedMediaTableSortProps.TYPE),
                  setSortDirection: onSortingChange(RelatedMediaTableSortProps.TYPE),
                  isColumnMarked: isColumnMarked(RelatedMediaTableSortProps.TYPE)
                },
                {
                  label: 'tags',
                  // widthPercentage: relatedMediaTableWidths.tags,
                  widthPx: relatedMediaTableWidths.tags,
                  sortDirection: getSortDirection(RelatedMediaTableSortProps.TAGS),
                  setSortDirection: onSortingChange(RelatedMediaTableSortProps.TAGS),
                  isColumnMarked: isColumnMarked(RelatedMediaTableSortProps.TAGS)
                },
                {
                  label: 'genre',
                  // widthPercentage: relatedMediaTableWidths.genre,
                  widthPx: relatedMediaTableWidths.genre,
                  sortDirection: getSortDirection(RelatedMediaTableSortProps.GENRE),
                  setSortDirection: onSortingChange(RelatedMediaTableSortProps.GENRE),
                  isColumnMarked: isColumnMarked(RelatedMediaTableSortProps.GENRE)
                },
                {
                  label: 'status',
                  // widthPercentage: relatedMediaTableWidths.status,
                  widthPx: relatedMediaTableWidths.status,
                  sortDirection: getSortDirection(RelatedMediaTableSortProps.STATUS),
                  setSortDirection: onSortingChange(RelatedMediaTableSortProps.STATUS),
                  isColumnMarked: isColumnMarked(RelatedMediaTableSortProps.STATUS)
                }
              ]}
              style={ { position: 'sticky', top: 0, zIndex: 1 } }
            />
            <TableBodyContainer style={ { overflow: 'visible' } }>
              {projects.map(project => (
                <TableBodyLine
                  key={project.id}
                  cells={[
                    {
                      // widthPercentage: relatedMediaTableWidths.title,
                      widthPx: relatedMediaTableWidths.title,
                      children: <Text1 bold overflowEllipsis>{project.name}</Text1>,
                      isColumnMarked: isColumnMarked(RelatedMediaTableSortProps.TITLE)
                    },
                    {
                      // widthPercentage: relatedMediaTableWidths.type,
                      widthPx: relatedMediaTableWidths.type,
                      children: project.type,
                      isColumnMarked: isColumnMarked(RelatedMediaTableSortProps.TYPE)
                    },
                    {
                      // widthPercentage: relatedMediaTableWidths.tags,
                      widthPx: relatedMediaTableWidths.tags,
                      children: <TableTagsCell tags={project.tags} />,
                      isColumnMarked: isColumnMarked(RelatedMediaTableSortProps.TAGS)
                    },
                    {
                      // widthPercentage: relatedMediaTableWidths.genre,
                      widthPx: relatedMediaTableWidths.genre,
                      children: <Text1 overflowEllipsis>{project.genresAsString}</Text1>,
                      isColumnMarked: isColumnMarked(RelatedMediaTableSortProps.GENRE)
                    },
                    {
                      // widthPercentage: relatedMediaTableWidths.status,
                      widthPx: relatedMediaTableWidths.status,
                      children: capitalize(project.status.toLowerCase()),
                      style: {
                        color: isProjectPublished(project.status)
                          ? styles.primary
                          : styles.primaryContent
                      },
                      isColumnMarked: isColumnMarked(RelatedMediaTableSortProps.STATUS)
                    }
                  ]}
                />
              ))}
            </TableBodyContainer>
          </TableContainer>
        )
        : (
          <NoneLabel />
        )}

      {showPopup &&
        <ObjectsPopupSelector
          title='Manage Related Media'
          onClose={closePopup}
          onSubmit={setSelectedProjectsList}
          objectsList={vovProjectList}
          selectedObjectsList={selectedObjectsList}
          setSelectedList={setSelectedList}
        />
      }

    </SectionContainer>
  )
}

const RelatedMediaSection = inject(PROJECT_STORE)(observer(RelatedMediaSectionComponent))
export { RelatedMediaSection }
